import React from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';

import Button from './Button';
import styles from './PrimaryButton.css';

/**
 * Generic UI primary button
 * @param {object} props - props
 * @returns {React.Component} the rendered button
 */
const PrimaryButton = props => {
  const { className, children, style, ...otherProps } = props;

  return (
    <Button style={classnames(styles.primaryButton, className, style)} {...otherProps}>
      {children}
    </Button>
  );
};

PrimaryButton.propTypes = {
  className: propTypes.string,
  children: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
  style: propTypes.string
};

PrimaryButton.defaultProps = {
  className: null,
  style: null
};

export default PrimaryButton;
